<template>
  <v-list-item :title="hit.name" :to="url">
    <template #prepend>
      <ImageField
        :src="hit.image"
        width="80"
        aspect-ratio="1"
        class="mr-2"
        fit="cover"
      />
    </template>
    <template #subtitle>
      <span v-if="hit.store" class="text-caption">
        By
        <router-link
          :to="{
            name: 's-handle',
            params: { handle: hit.store.handle },
          }"
        >
          {{ hit.store.name }}
        </router-link>
      </span>
    </template>
    <div>
      <div class="text-3 text-primary font-semibold">
        <EventDateTime :event="hit" start-only />
      </div>
      <div class="text-3.5">
        <span v-if="hit.price_min < hit.price">
          From {{ formatPrice(hit.price_min) }}
        </span>
        <span v-else>{{ formatPrice(hit.price) }}</span>
      </div>
    </div>
  </v-list-item>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import EventDateTime from "@/components/elements/event/EventDateTime";
import type { EventResult } from "../models";

export default defineComponent({
  name: "SearchContentEventItem",
  components: { EventDateTime },
  props: {
    hit: { type: Object as PropType<EventResult>, required: true },
  },
  computed: {
    url() {
      return {
        name: "events-handle",
        params: { handle: this.hit.handle },
      };
    },
  },
  methods: {
    formatPrice,
  },
});
</script>
